import React from "react"

interface DateRangeFilterProps {
  startDate: string
  endDate: string
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  return (
    <div className={"flex-1 flex-row flex gap-4"}>
      <div className="form-control">
        <label className="label">
          <span className="label-text">Начальная дата</span>
        </label>
        <input
          type="date"
          className="input input-bordered"
          value={startDate}
          onChange={e => onStartDateChange(e.target.value)}
        />
      </div>
      <div className="form-control">
        <label className="label">
          <span className="label-text">Конечная дата</span>
        </label>
        <input
          type="date"
          className="input input-bordered"
          value={endDate}
          onChange={e => onEndDateChange(e.target.value)}
        />
      </div>
    </div>
  )
}
